'use strict';

const castBoolean = require('../../cast/boolean');

/*!
 * ignore
 */

module.exports = function(val) {
  const path = this != null ? this.path : null;
  return castBoolean(val, path);
};



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/schema/operators/exists.js
// module id = 459
// module chunks = 0